"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fetchOnce = _interopRequireDefault(require("./fetchOnce"));

var _realTime = _interopRequireDefault(require("./realTime"));
/* eslint-disable react/jsx-props-no-spreading */


var FirestoreTable = function FirestoreTable(props) {
  // eslint-disable-next-line react/prop-types
  var fetchOnce = props.fetchOnce,
      children = props.children,
      onSort = props.onSort,
      sortDirection = props.sortDirection,
      rest = (0, _objectWithoutProperties2["default"])(props, ["fetchOnce", "children", "onSort", "sortDirection"]);

  if (fetchOnce) {
    return /*#__PURE__*/_react["default"].createElement(_fetchOnce["default"], rest, children);
  }

  return /*#__PURE__*/_react["default"].createElement(_realTime["default"], rest, children);
};

FirestoreTable.propTypes = {
  /** The path of the Firestore collection e.g. `/books` */
  collection: _propTypes["default"].string.isRequired,

  /** Query function for firestore. */
  query: _propTypes["default"].func,

  /** It fetch the collection data once. */
  fetchOnce: _propTypes["default"].bool,

  /** Specifies the default sorting direction on an unsorted column. Valid options include 'asc' and 'desc'.
  * The default is 'asc' for sorting in ascending order. */
  defaultSortDirection: _propTypes["default"].oneOf(['asc', 'desc']),

  /** The column fieldName that controls the sorting order. */
  sortedBy: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object])
};
FirestoreTable.defaultProps = {
  query: undefined,
  fetchOnce: false,
  defaultSortDirection: 'asc',
  sortedBy: undefined,
  children: []
};
var _default = FirestoreTable;
exports["default"] = _default;